import { reqAPI } from "../utils/fetch-request";

export async function uploadBatchFile(BatchFile)
{
  return reqAPI(`api/merchant/transaction-batches/upload`, BatchFile, "POST", true)
}

export async function getDataBatchFile(uuid)
{
  return reqAPI(`api/merchant/transaction-batches/${uuid}`);
}

export async function getDataBatchFileFailed(uuid)
{
  return reqAPI(`api/merchant/transaction-batches/${uuid}/failed-transactions/download`, {}, 'GET', false, 'blob');
}

export async function fixErrorsBatchfileByRow(formData)
{
  return reqAPI(`api/merchant/transaction-batches/fix-errors`, formData, "POST", true);
}

export async function deleteBatchfileByRow(uuid)
{
  return reqAPI(`api/merchant/transfer-batches/${uuid}`, null, "DELETE", false);
}

export async function checkAccountNumber(formData)
{
  return reqAPI(`api/merchant/check-account`, formData, "POST", true);
}

export async function getBatchSummary(uuid)
{
  return reqAPI(`api/merchant/transaction-batches/${uuid}/summary`);
}

export async function getBanks(isEwallet = false)
{
  const params = isEwallet ? { is_ewallet: 1 } : {};
  return reqAPI(`api/merchant/bank`, params);
}

export async function getBalance()
{
  return reqAPI(`api/merchant/balance`);
}

export async function sendOtp(formData)
{
  return reqAPI(`api/merchant/payment/send-otp`, formData, "POST", true);
}

export async function verifyOtp(formData)
{
  return reqAPI(`api/merchant/payment/verify-otp`, formData, "POST", true);
}

export async function cancelBatch(uuid)
{
  const formData = new FormData();
  formData.append('uuid', uuid);
  return reqAPI(`api/merchant/transaction-batches/cancel`, formData, "POST", true);
}

export async function getRecipients(accountType)
{
  return reqAPI(`api/merchant/recipients`, { account_type: accountType });
}

export async function createRecipient(payload)
{
  return reqAPI(`api/merchant/recipients`, payload, "POST");
}

export async function deleteRecipient(id)
{
  return reqAPI(`api/merchant/recipients/${id}`, null, "DELETE");
}

export async function getSingleTransferAdminFee(bankId)
{
  return reqAPI(`api/merchant/single-transfer/admin-fee/${bankId}`);
}

export async function createSingleTransfer(payload)
{
  return reqAPI(`api/merchant/single-transfer/create`, payload, "POST");
}